import type * as React from 'react';

import type { InlineProps } from '@gitbook/slate-react';
import { Emoji } from '@gitbook/spine-react';

/*
 * Basic renderer for an inline emoji
 */
export function BasicInlineEmoji(props: InlineProps): React.ReactElement {
    const { node, attributes } = props;

    const emojiCode = node.data.get('code');

    return (
        <span className="inline-flex align-middle" {...attributes}>
            <Emoji code={emojiCode} />
        </span>
    );
}
